

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth";


const firebaseConfig = {
  apiKey: "AIzaSyDPEXzJxQK68UZ2C6UXIGW4qkWDHvGxraw",
  authDomain: "euphoni-mind.firebaseapp.com",
  projectId: "euphoni-mind",
  storageBucket: "euphoni-mind.appspot.com",
  messagingSenderId: "407369429058",
  appId: "1:407369429058:web:893aaa4bf46077cfcf7ddb",
  measurementId: "G-W7NV9KJ9JC"
};




// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

export default app;


// //
// // Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries

// // Your web app's Firebase configuration
// // For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyDPEXzJxQK68UZ2C6UXIGW4qkWDHvGxraw",
//   authDomain: "euphoni-mind.firebaseapp.com",
//   projectId: "euphoni-mind",
//   storageBucket: "euphoni-mind.appspot.com",
//   messagingSenderId: "407369429058",
//   appId: "1:407369429058:web:893aaa4bf46077cfcf7ddb",
//   measurementId: "G-W7NV9KJ9JC"
// };

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);


